module.exports = __webpack_public_path__ + "img/gleeder-desktop-banner.d653a47e.png";